import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { FRESHCHAT_WEB_WIDGET_CONVERTER_TOKEN, FreshchatWebWidgetConverter } from './freshchat-web-widget.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        freshchatWebWidgetFeature: {
          module: () => import('./freshchat-web-widget.module').then((m) => m.FreshchatWebWidgetModule),
          cmsComponents: ['freshchat_web_widget']
        },
      }
    }),
    {
      provide: FRESHCHAT_WEB_WIDGET_CONVERTER_TOKEN,
      useExisting: FreshchatWebWidgetConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        freshchat_web_widget: FRESHCHAT_WEB_WIDGET_CONVERTER_TOKEN
      },
      multi: true
    },
  ]
})
export class FreshchatWebWidgetFeatureModule {}
